import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('temporaryDrawer', [
  'container',
  'scrollContainer',
  'anchorLeft',
  'anchorRight',
  'widthMedium',
  'widthLarge',
  'stickyNone',
  'stickyActions',
  'stickyHeadingGroup',
]);

const getTemporaryDrawerCss = css`
  position: fixed;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: var(--cds-spacing-200) 0;
  background: #fff;

  .${classes.container} {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .${classes.scrollContainer} {
    flex: 1 1 auto;
  }

  &.${classes.anchorLeft} {
    left: 0;
    right: auto;
  }

  &.${classes.anchorRight} {
    right: 0;
    left: auto;
  }

  &.${classes.stickyActions} {
    padding-top: 0;

    .${classes.scrollContainer} {
      padding-top: var(--cds-spacing-200);
    }
  }

  &.${classes.stickyHeadingGroup} {
    padding-bottom: 0;

    .${classes.scrollContainer} {
      padding-bottom: var(--cds-spacing-200);
    }
  }

  &.${classes.stickyNone} {
    padding: 0;

    .${classes.scrollContainer} {
      padding: var(--cds-spacing-200) 0;
    }
  }

  ${breakpoints.up('sm')} {
    max-width: 450px;
    padding: var(--cds-spacing-400) 0;

    &.${classes.stickyActions} {
      padding-top: 0;

      .${classes.scrollContainer} {
        padding-top: var(--cds-spacing-400);
      }
    }

    &.${classes.stickyHeadingGroup} {
      padding-bottom: 0;

      .${classes.scrollContainer} {
        padding-bottom: var(--cds-spacing-400);
      }
    }

    &.${classes.stickyNone} {
      padding: 0;

      .${classes.scrollContainer} {
        padding: var(--cds-spacing-400) 0;
      }
    }
  }

  ${breakpoints.up('md')} {
    padding: var(--cds-spacing-600) 0;

    &.${classes.stickyActions} {
      padding-top: 0;

      .${classes.scrollContainer} {
        padding-top: var(--cds-spacing-600);
      }
    }

    &.${classes.stickyHeadingGroup} {
      padding-bottom: 0;

      .${classes.scrollContainer} {
        padding-bottom: var(--cds-spacing-600);
      }
    }

    &.${classes.stickyNone} {
      padding: 0;

      .${classes.scrollContainer} {
        padding: var(--cds-spacing-600) 0;
      }
    }

    &.${classes.widthMedium} {
      max-width: 512px;
    }

    &.${classes.widthLarge} {
      max-width: 768px;
    }
  }

  ${breakpoints.up('lg')} {
    &.${classes.widthMedium} {
      max-width: 720px;
    }

    &.${classes.widthLarge} {
      max-width: 1080px;
    }
  }
`;

export default getTemporaryDrawerCss;
